import * as React from 'react';
import { ROOT_PAGE } from 'constants/pages';
import ChevronRight from 'svg/ChevronRight';
import Home from 'svg/Home';
import Link from 'components/Link';
import { BreadcrumbItem } from './types';

interface Props {
  breadcrumbs: BreadcrumbItem[];
}

export default function BreadcrumbsBar({ breadcrumbs }: Props) {
  return (
    <div className="border-b border-color-border-input-lightmode bg-color-bg-lightmode-primary px-4 py-ds-md dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-primary sm:px-ds-2xl">
      <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-ds-sm">
        <Link
          href={ROOT_PAGE}
          className="p-ds-xs text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
          aria-label="Home"
        >
          <Home className="w-5" />
        </Link>
        {breadcrumbs.map((breadcrumb, index) => (
          <React.Fragment key={index}>
            <ChevronRight className="w-5 shrink-0 text-color-text-lightmode-inactive dark:text-color-text-darkmode-inactive" />
            {breadcrumb.isActivePage ? (
              <span className="typography-product-element-label whitespace-nowrap px-ds-sm py-ds-xs text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary">
                {breadcrumb.label}
              </span>
            ) : (
              <Link
                href={breadcrumb.url}
                className="typography-product-element-label whitespace-nowrap px-ds-sm py-ds-xs text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary"
              >
                {breadcrumb.label}
              </Link>
            )}
          </React.Fragment>
        ))}
      </nav>
    </div>
  );
}
